import { noDataFilter } from "app/filters/ngFilters";

import type { ITableCellProps } from "../interfaces/ITableCellProps";
import { trackEvent } from "../SWReactTableTrackEvent";

import { UpgradeLink } from "./UpgradeLink";

/**
 * @deprecated Use TextAnchorCell from @similarweb/pro-logic-components instead
 * @see {@link https://gitlab.int.similarweb.io/pro-frontend/pro-logic-components/-/blob/master/src/table/cells/components/core/TextAnchorCell/TextAnchorCell.tsx}
 */
export const LinkCell = ({ value, tableOptions }: ITableCellProps) => {
    const newValue = noDataFilter()(value, "^\\s*n\\/a\\s*$", "-");
    if (newValue !== "grid.upgrade") {
        const isValidLink = newValue && newValue !== "-";
        return (
            <div className="link-cell cell-padding cell-innerText">
                <div className="swTable-content-large text">{newValue}</div>
                {isValidLink ? (
                    <a
                        className="swTable-linkOut sw-icon-bounce-rate"
                        href={`http://${newValue}`}
                        onClick={() => {
                            trackEvent(tableOptions, "External Link", newValue, "click");
                        }}
                        target="_blank"
                        rel="noreferrer"
                    />
                ) : null}
            </div>
        );
    } else {
        return <UpgradeLink />;
    }
};
LinkCell.displayName = "LinkCell";
